module.exports = __webpack_public_path__ + "img/other-purchase.570a1d6a.svg";